import { match, P } from 'ts-pattern';

import { Button } from '@nesso/ui/primitives/button';
import { Card, CardContent } from '@nesso/ui/primitives/card';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@nesso/ui/primitives/dialog';

import { useNoteCopyIntro } from '../../model/use-note-copy-intro';

type Props = {
    sessionId: string;
};

export function CopySessionNoteIntroDialog({ sessionId }: Props) {
    const { isOpen, noteText, onDismiss } = useNoteCopyIntro(sessionId);

    return match({ isOpen, noteText })
        .with({ isOpen: true, noteText: P.nonNullable }, ({ noteText }) => (
            <Dialog open onOpenChange={(open) => !open && onDismiss()}>
                <DialogContent
                    className="p-6 rounded-md w-full max-w-[calc(100%-2rem)] sm:max-w-md"
                    onPointerDownOutside={(e) => e.preventDefault()}
                >
                    <DialogHeader className="gap-1.5">
                        <DialogTitle className="text-left">
                            Review your note and copy it to your EHR
                        </DialogTitle>
                        <DialogDescription className="text-left">
                            Here&rsquo;s the unedited version of your note for reference
                        </DialogDescription>
                    </DialogHeader>
                    <Card className="bg-muted/40">
                        <CardContent className="max-h-[50svh] overflow-y-auto">
                            <pre className="font-sans text-sm text-foreground whitespace-pre-wrap">
                                {noteText}
                            </pre>
                        </CardContent>
                    </Card>
                    <DialogFooter className="flex-row sm:justify-end">
                        <Button onClick={onDismiss} className="w-full sm:w-auto">
                            Got It
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        ))
        .otherwise(() => null);
}
